"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRepetitionTimes = void 0;
const getRepetitionTimes = (config) => {
    return config.nTimes.enabled
        ? config.nTimes.value || 0
        : config.unLimitedTimes.enabled
            ? config.unLimitedTimes.value || 1
            : config.list.enabled
                ? config.list.options.filter(o => o.label !== '').length || 0
                : 1;
};
exports.getRepetitionTimes = getRepetitionTimes;
